import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Particle from "../Particle";
import {
  AiFillGithub,
  AiOutlineTwitter
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
// import Project from "../../Assets/projetc.jpg";



function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData); // Form data console me dekh sakte ho
    alert("Form submitted!");
    // Yahan API call ya email sending logic dal sakte ho
  };

  return (
    <Container fluid className="contact-section" style={{ position: "relative" }}>
      <Particle /> {/* Particle background */}
      <Container style={{ position: "relative", zIndex: 1, paddingTop: "50px" }}>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col md={6} style={{ padding: "30px" }}>
            <h1
              style={{
                textAlign: "center",
                marginBottom: "20px",
                // backgroundImage: `url(${Project})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white", // text color set karo jo image pe visible ho
                padding: "50px 20px",
                borderRadius: "10px" // optional
              }}
            >
              Hello. Let's work together on your next project.
            </h1>

            <p style={{ textAlign: "center", text: "white" }}>
              For commissions and project inquiries, please email:
              <strong> hello@junedigann.com</strong>
            </p>
            <p style={{ textAlign: "center" }}>or send a message via this form.</p>

            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formFirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your first name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formLastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your last name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formMessage">
                <Form.Label>Write a message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </Form.Group>

              <Button variant="primary" type="submit" style={{ marginTop: "10px" }}>
                Submit
              </Button>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Chandu7a7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/chandu7a7/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;
